import axiosInstance from '../../../config/axiosInstance';
import { CustomerDetailValidation } from "../View/Validation/CustomerDetailValidation";

const handleChange = (event, formData, setFormData) => {
    const { name, value } = event.target;
    setFormData({
        ...formData,
        [name]: value,
    });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
    event.preventDefault();
   const formErrors = CustomerDetailValidation(formData);
   setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.formData.UserID = UserID;
            const response = await axiosInstance.post(`/Customer/CreateCustomer`,formData);  
           localStorage.setItem('ClientCompanyID', response.data.CustomerID);
         
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
        }
    }
    else {
        return "Validation Error";
    }
};

export { handleChange, handleSubmit };
